export default "__VITE_ASSET__68f09c33__"